<path
    d="M11.4807 6.1862L12 6.68455L12.5193 6.1862C13.447 5.29596 14.7044 4.75 16.0909 4.75C18.9402 4.75 21.25 7.0598 21.25 9.90909C21.25 12.5032 19.8356 14.5608 18.0169 16.1398C16.1975 17.7194 14.0516 18.7475 12.7931 19.2652C12.2797 19.4764 11.7203 19.4764 11.2069 19.2652C9.9484 18.7475 7.80251 17.7194 5.98314 16.1398C4.16437 14.5609 2.75 12.5032 2.75 9.90909C2.75 7.0598 5.0598 4.75 7.90909 4.75C9.2956 4.75 10.553 5.29596 11.4807 6.1862Z"
    stroke="currentColor"
    stroke-width="1.5"
/>
